module.exports = __webpack_public_path__ + "static/img/third2_1.af505a4f.png";